import { useEffect, useState } from "react";
import { useGetEventSlot } from "../../../api/EventSlot/EventSlotApi";
import { Quote } from "../../../api/Quote/Quote";
import { isSlotExpired, isSlotExpiredMid } from "../../../app/utils";

export const useQuoteSelectedEvent = (
  quote: Quote | null,
  callbackEnd: Function,
  callbackPreExpired?: Function | null
) => {
  const [isMid, setMid] = useState(false);
  const [isEnd, setEnd] = useState(false);
  const { data: selectedEventSlot } = useGetEventSlot(quote?.eventSlotId);

  useEffect(() => {
    if (isEnd) {
      return;
    }
    if (quote && quote.eventSlotExpire) {
      const interval = setInterval(() => {
        if (isSlotExpired(quote, selectedEventSlot) && !isEnd) {
          clearInterval(interval);
          if (callbackEnd) {
            callbackEnd();
            return;
          }
          setEnd(true);
        }

        if (isSlotExpiredMid(quote, selectedEventSlot) && !isMid) {
          if (callbackPreExpired) {
            callbackPreExpired();
          }
          setMid(true);
        }
      }, 1000);

      return () => {
        clearInterval(interval);
        setMid(false);
        setEnd(false);
      };
    }
  }, [quote, selectedEventSlot, callbackPreExpired, callbackEnd, isMid, isEnd]);
};
